import { initializeApp } from 'firebase/app';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';
import * as Sentry from 'utils/sentry';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const database = getFirestore(app);

export const subscribeToNewVersions = (
  app_id: string,
  callback: (v: number) => void
) =>
  onSnapshot(doc(database, 'deploys', app_id), (doc) => {
    if (doc.exists()) {
      const new_version = doc.data() as { version: number };
      callback(new_version.version);
    } else {
      Sentry.warn('Unable to establish firestore connection');
    }
  });
